module.exports = __webpack_public_path__ + "media/images/neutral-cb723f2bfbd759aaac3d6fe21cb2330a.svg";